<template>
   <div class="bg-circle-user text-center p-1 rounded-circle" 
         :style="{'background-color': circleUser.bg_color , 'color': circleUser.text_color}" 
         :title="circleUser.name + ' (' + circleUser.id + ')'"
         >
      <b>{{circleUser.capitals}}</b>
   </div>
</template>

<script>
export default {
   props: {
      circleUser: Object
   },
}
</script>

<style scoped>
.bg-circle-user {
   width: 31px;
   height: 28px;
   font-size: 12px;
}
</style>